import { useEffect } from 'react'
import { Platform, AppState, AppStateStatus } from 'react-native'
import Analytics from '../utility/analytics'

/**
 * Custom hook to detect when the app is about to be closed or goes to background
 * Works on both web and mobile platforms
 */
export const useAppClosure = (): void => {
  useEffect(() => {
    const handleAppClosure = async () => {
      Analytics.flush()
    }

    if (Platform.OS === 'web') {
      // Web platform: Listen for beforeunload, unload, and pagehide events
      const handleBeforeUnload = () => {
        handleAppClosure()
        // Note: Some browsers may not show custom messages in beforeunload anymore
        // but the event still fires for logging purposes
      }

      // const handleUnload = () => {
      //   handleAppClosure()
      // }

      // const handlePageHide = (event: PageTransitionEvent) => {
      //   // pagehide is more reliable than unload in modern browsers
      //   handleAppClosure()
      // }

      // const handleVisibilityChange = () => {
      //   if (document.visibilityState === 'hidden') {
      //     handleAppClosure()
      //   }
      // }

      // Add event listeners for web
      window.addEventListener('beforeunload', handleBeforeUnload)
      // window.addEventListener('unload', handleUnload)
      // window.addEventListener('pagehide', handlePageHide)
      // document.addEventListener('visibilitychange', handleVisibilityChange)

      // Cleanup function for web
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload)
        // window.removeEventListener('unload', handleUnload)
        // window.removeEventListener('pagehide', handlePageHide)
        // document.removeEventListener('visibilitychange', handleVisibilityChange)
      }
    } else {
      // Mobile platform: Listen for AppState changes
      const handleAppStateChange = (nextAppState: AppStateStatus) => {
        // Log when app goes to background or becomes inactive
        if (nextAppState === 'background') {
          handleAppClosure()
        }
      }

      // Add AppState listener for mobile
      const subscription = AppState.addEventListener('change', handleAppStateChange)

      // Cleanup function for mobile
      return () => {
        subscription?.remove()
      }
    }
  }, [])
}
